<div class="container">

  <div class="include-box">

    <div class="text">PACIENTE NÃO POSSUI REGISTRO DE {{aba}}</div>

    @if(aba !== 'ENFERMAGEM' && aba !== 'FARMÁCIA' && aba !== 'PSICOLOGIA'){

    <div *ngIf="!disabled">
      <div class="btn-include" (click)="onClick()">

        <img class="add-image" src="assets/icons/add_button.svg">

        <span class="include">INCLUIR</span>
      </div>
    </div>

    <div *ngIf="disabled">
      <div class="btn-include">

        <img class="add-image" style="cursor: not-allowed;" src="assets/icons/add_button_disabled.svg">

        <span class="include-disabled">INCLUIR</span>
      </div>
    </div>
    }

    @else if (aba === 'ENFERMAGEM') {

    <div class="flex justify-center" style="gap: 10px; padding: 0px 10px;">
      <app-button (click)="onClick('nursingHistory')" [text]="'INCLUIR HISTÓRICO'" type="secondary-bold"
        [disabled]="disabled"></app-button>

      <app-button (click)="onClick('nursingAvaliation')" [text]="'INCLUIR AVALIAÇÃO'" type="secondary-bold"
        [disabled]="disabled"></app-button>

      <app-button (click)="onClick('nursingDiagnostic')" [text]="'INCLUIR DIAGNÓSTICO'" type="secondary-bold"
        [disabled]="disabled"></app-button>
    </div>
    }

    @else if (aba === 'FARMÁCIA') {
    <div class="flex justify-center" style="gap: 10px; padding: 0px 10px;">
      <app-button (click)="onClick('attention')" [text]="'INCLUIR ATENÇÃO'" type="secondary-bold"
        [disabled]="disabled"></app-button>

      <app-button (click)="onClick('intervention')" [text]="'INCLUIR INTERVENÇÃO'" type="secondary-bold"
        [disabled]="disabled"></app-button>
    </div>
    }

    @else if (aba === 'PSICOLOGIA') {
    <div class="flex justify-center" style="gap: 10px; padding: 0px 10px;">
      <app-button (click)="onClick('psychologyAssessment')" [text]="'INCLUIR AVALIAÇÃO PSICOSSOCIAL'"
        type="secondary-bold" [disabled]="disabled"></app-button>

      <app-button (click)="onClick('psychologyBackground')" [text]="'INCLUIR ANTECEDENTES PESSOAIS'" type="secondary-bold"
        [disabled]="disabled"></app-button>

      <app-button (click)="onClick('evolutionConduct')" [text]="'INCLUIR EVOLUÇÃO E CONDUTA'" type="secondary-bold"
        [disabled]="disabled"></app-button>

      <app-button (click)="onClick('distress')" [text]="'INCLUIR DISTRESS'" type="secondary-bold"
        [disabled]="disabled"></app-button>
    </div>
    }
  </div>
</div>